import ContainerValidation from './Components/ContainerValidation';
import HeaderValidation from './Components/HeaderValidation';
import BodyValidation from './Components/BodyValidation';
import React from 'react';
import ChooseValidationTypeApp from './Functionality/ChooseValidationTypeApp';
import useForbiddenValidation from './Functionality/useForbiddenValidation';
import {allowedDocumentListToLabel} from "./Model/Model";
import {CustomAddChip} from "../../../../components/CustomAddChip";
import {filterByLabelEmailPhone} from "../../../../Apis/functions";
import AllowedDocumentsList from "./Model/AllowedDocumentsList";

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const ChooseValidationType = () => {
    const { t,
        guardFlowId,
        selectedList,
        setSelectedList,
        getUrl,
        getInvitationById, backUrl } = ChooseValidationTypeApp();
    useForbiddenValidation({getInvitationById});

    return (
        <ContainerValidation>
            <HeaderValidation url={backUrl}/>

            <BodyValidation
                click={() => { getUrl() }}
                btnDisabled={selectedList.length === 0}
            >
                <>
                    <div className="row">
                        <div className="col-12 d-flex flex-column justify-content-center align-items-center">
                            <p className="fs-24-to-18 ibl-font-w-600 font-color-general-950 text-center">
                                { t(guardFlowId ? "please_choose_one_of_following_documents_to_proceed_with_validation": "please_choose_validation_type")}
                            </p>
                        </div>
                    </div>

                    <div className={"col-12 mt-5"}>
                        <CustomAddChip
                            autocompleteId={'slt_cvt_allowed_documents'}
                            buttonId={'btn_cvt_allowed_documents'}
                            required={true}
                            data={allowedDocumentListToLabel(AllowedDocumentsList, guardFlowId)}
                            selectedList={selectedList}
                            setSelectedList={setSelectedList}
                            noDisabledChip={true}
                            showRenderOption={false}
                            filterOptions={filterByLabelEmailPhone}
                            maxLength={1}
                            hideButton={true}
                            reset={false}
                        />
                    </div>
                </>
            </BodyValidation>
        </ContainerValidation>
    )
}

export default ChooseValidationType
